import { render, staticRenderFns } from "./DataCenterHeader.vue?vue&type=template&id=5f5c059a&scoped=true"
import script from "./DataCenterHeader.vue?vue&type=script&lang=js"
export * from "./DataCenterHeader.vue?vue&type=script&lang=js"
import style0 from "./DataCenterHeader.vue?vue&type=style&index=0&id=5f5c059a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5c059a",
  null
  
)

export default component.exports